export default __webpack_public_path__ + "static/media/cakenode-logo.9b32d994.svg";